import "./PerformanceIncomeScheduleModal.scss";
import { Trans, useTranslation } from "react-i18next";
import defaultContent from "../../../../content/monthlyPerformanceDashboard";
import { LeafModal } from "../../../../common/leaf/LeafModal/LeafModal";
import LeafTable from "../../../../common/leaf/LeafTable/LeafTable";
import { BonusScheduleDetail } from "../../../../services/MonthlyPerformanceIncome/monthlyPerformanceIncomeAPI.types";

type Props = {
  showPerformanceModal: boolean;
  handleModalClose?: Function;
  bonusDetails: BonusScheduleDetail[];
};

const PerformanceIncomeScheduleModal = ({ showPerformanceModal, handleModalClose, bonusDetails }: Props) => {
  const { t } = useTranslation(["monthlyPerformanceDashboard"]);
  const headers = [
    { value: t("performanceBonusTotalMonthlyPv", defaultContent["performanceBonusTotalMonthlyPv"]), width: "50%" },
    { value: t("performanceBonus", defaultContent["performanceBonus"]), width: "50%" },
  ];

  if (!showPerformanceModal) {
    return <></>;
  }

  const createRows = (bonusDetails: BonusScheduleDetail[]) => {
    const rows = new Array(bonusDetails.length);

    bonusDetails.forEach((row, index) => {
      if (!row?.volume || !row?.percent) {
        return null;
      }

      let volumeValue, percentValue;
      const volume = row.volume.Formatted;
      const percent = row.percent.Actual;

      switch (index) {
        case 0:
          volumeValue = (
            <Trans components={{ 1: <strong /> }}>
              {t("bonusScheduleTableVolume", defaultContent["bonusScheduleTableVolume"], {
                volume: volume,
              })}
            </Trans>
          );

          percentValue = (
            <Trans components={{ 1: <strong /> }}>
              {t("bonusScheduleTableFirstPercent", defaultContent["bonusScheduleTableFirstPercent"], {
                percent: percent,
              })}
            </Trans>
          );
          break;
        default:
          volumeValue = <strong>{volume}</strong>;
          percentValue = (
            <Trans components={{ 1: <strong /> }}>
              {t("bonusScheduleTablePercent", defaultContent["bonusScheduleTablePercent"], {
                percent: percent,
              })}
            </Trans>
          );
      }

      rows[index] = {
        row: [{ value: volumeValue }, { value: percentValue }],
      };
    });

    return rows;
  };

  const rows = createRows(bonusDetails);

  const title = t("performanceBonusSchedule", defaultContent["performanceBonusSchedule"]);

  return (
    <div className={"perfIncomeSchedule-container"}>
      <LeafModal
        open={showPerformanceModal}
        onCloseCallbackFn={handleModalClose}
        title={title}
        id={"perfIncomeSchedule-container"}
      >
        <div className="perfIncomeSchedule-container__table">
          <LeafTable header={headers} rows={rows} columnAlign={"center"} headerStyle={"default"} hideHeader={false} />
        </div>
      </LeafModal>
    </div>
  );
};

export default PerformanceIncomeScheduleModal;
